import { createAsyncThunk } from '@reduxjs/toolkit';
import { claimCashbackAsync, getCashbackAsync } from './CashbackBonus.requests';
import { SuccessToast } from '../../components';

export const getCashback = createAsyncThunk('getCashback', async () => {
  const { data } = await getCashbackAsync();
  return data;
});

export const claimCashback = createAsyncThunk('claimCashback', async () => {
  const { message, data } = await claimCashbackAsync();

  SuccessToast(message);

  return data;
});
